<div class="flex flex-wrap mt-8 mb-6">

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo="../../members"></app-btn-back>
        <div class="flex gap-2 justify-center">
            @if (activeTab === 'sessions' && academicYear == group?.academicYear && group?.memberStatus ==
            membershipStatus.active && ((myRoles$ |
            async)?.management || facultyId == user?.uid)) {
            <app-btn-action label="New Session" (clicked)="onAddSession()" bgColor="bg-primary-500"
                textColor="text-white" icon="fa fa-add"></app-btn-action>
            }
            @if (activeTab === 'assignments' && academicYear == group?.academicYear && group?.memberStatus ==
            membershipStatus.active && ((myRoles$ |
            async)?.management || facultyId == user?.uid)) {
            <app-btn-route routeTo="assignments/create" colors="bg-primary-500 hover:bg-primary-300"
                textColor="text-white" icon="fa fa-add" btnText="New Assignment"></app-btn-route>
            }
        </div>
    </div>

    <div class="flex flex-row justify-between mb-2 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500 items-center flex">
            {{ user?.uid === facultyId ? 'My Teaching' : (teacher?.name ?? 'Teacher') }} Workspace
        </h1>
        <div class="flex flex-row gap-1 items-center min-w-56">
            <span class="text-sm text-primary-300 whitespace-nowrap mr-2 text-right">Academic Year</span>
            <select
                class="min-w-16 border-0 px-2 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                [(ngModel)]="academicYear" (change)="onAcademicYearChange($event)">
                @for (item of academicYears; track $index) {
                <option [value]="item">{{ item }}</option>
                }
            </select>
        </div>
    </div>

    <div class="w-full">
        <!-- Tabs Navigation -->
        <div class="border-b border-gray-200">
            <nav class="flex space-x-4">
                <app-btn-tab tabName="sessions" routerLink="sessions" queryParamsHandling="merge"
                    [isActive]="activeTab === 'sessions'">
                </app-btn-tab>
                <app-btn-tab tabName="lessons" routerLink="lessons" queryParamsHandling="merge"
                    [isActive]="activeTab === 'lessons'">
                </app-btn-tab>
                <app-btn-tab tabName="assignments" routerLink="assignments" queryParamsHandling="merge"
                    [isActive]="activeTab === 'assignments'">
                </app-btn-tab>
                <app-btn-tab tabName="overview" routerLink="overview" queryParamsHandling="merge"
                    [isActive]="activeTab === 'overview'">
                </app-btn-tab>
                <app-btn-tab tabName="archive" routerLink="archive" queryParamsHandling="merge"
                    [isActive]="activeTab === 'archive'">
                </app-btn-tab>
            </nav>
        </div>

        <!-- Tab Content -->
        <div class="mt-6">
            <router-outlet></router-outlet>
        </div>
    </div>